import { useEffect, useState } from 'react'

const formatTime = (timeZone: string | null): string => {
  const options: Intl.DateTimeFormatOptions = {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }
  try {
    return new Intl.DateTimeFormat('es-ES', { ...options, ...(timeZone ? { timeZone } : {}) }).format(
      new Date(),
    )
  } catch {
    return new Intl.DateTimeFormat('es-ES', options).format(new Date())
  }
}

/** Live HH:MM:SS clock in the given timezone (browser timezone when null). */
export function useLiveClock(timeZone: string | null): string {
  const [time, setTime] = useState(() => formatTime(timeZone))

  useEffect(() => {
    setTime(formatTime(timeZone))
    const id = window.setInterval(() => setTime(formatTime(timeZone)), 1000)
    return () => window.clearInterval(id)
  }, [timeZone])

  return time
}
